import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { HeadingS } from 'uiComponents/atoms/Text/Headings'
import { fsXS, fsXXS } from 'uiComponents/constants/typography'

export const Links = styled.div`
  display: flex;
`

export const LinkBlock = styled.div`
  padding-right: 20px;

  &:last-child {
    padding-right: 0;
  }
`

export const LinkHeader = styled(HeadingS)`
  padding-bottom: 10px;
  font-size: ${fsXS}px;
`

export const StyledLink = styled(Link)`
  font-size: ${fsXXS}px;
  :hover {
    text-decoration: underline;
  }
`
